import React, { useEffect, useState } from 'react';
import { Modal } from '../shared/Modal';
import { kpiService } from '../../services/kpiService';
import { mapSupabaseError } from '../../utils/supabaseErrors';
import { formatPeriodLabel } from '../submissions/periodFormat';

export function KpiSubmissionDetailModal({ submission, onClose }) {
  const [items, setItems] = useState([]);
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [kpis, scoring] = await Promise.all([
          kpiService.getSubmissionKpis(submission.id),
          kpiService.getScoringRules(submission.kpi_system_id),
        ]);
        if (!active) return;
        setItems([...kpis].sort((a, b) => (a.metric_name || '').localeCompare(b.metric_name || '')));
        setRules(scoring);
      } catch (e) {
        if (active) setError(mapSupabaseError(e));
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [submission.id, submission.kpi_system_id]);

  const pointsFor = (defId) =>
    rules.find((r) => r.kpi_definition_id === defId && r.period === submission.period)?.points_for_achievement ?? 0;

  return (
    <Modal onClose={onClose} role="dialog" aria-modal="true" aria-label="KPI submission detail">
      <h3>KPI submission</h3>
      <p className="form-label"><strong>{submission.submitter?.name}</strong> · {formatPeriodLabel(submission.period, submission.period_start, submission.period_end)}</p>
      {error && <div className="error-message" role="alert">{error}</div>}
      {loading ? <p className="loading-msg">Loading…</p> : (
        <table className="kpi-bundle-table">
          <thead><tr><th>KPI</th><th>Target</th><th>Value</th><th>Met</th><th>Score</th></tr></thead>
          <tbody>
            {items.map((it) => {
              const met = Number(it.current_value) >= Number(it.target_value);
              const max = pointsFor(it.kpi_definition_id);
              const earned = met ? max : 0;
              return (
                <tr key={it.id || it.kpi_definition_id}>
                  <td>{it.metric_name || '—'}</td>
                  <td>{it.target_value ?? '—'}</td>
                  <td>{it.current_value ?? '—'}</td>
                  <td>{met ? '✓' : '✗'}</td>
                  <td>{earned} / {max}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      <div className="modal-buttons">
        <button type="button" className="btn-secondary" onClick={onClose}>Close</button>
      </div>
    </Modal>
  );
}
